export default __webpack_public_path__ + "static/media/default_empty_logo.2686d4ab.svg";